import React from "react";
import { Accordion } from "react-bootstrap";
import arrowleft from "../../../Assets/arrowleft.svg";
import arrowup from "../../../Assets/arrowup.svg";
import arrowdown from "../../../Assets/arrowdown.svg";
import {
  formatBrazilianCurrency,
  parseBrazilianNumber,
} from "../../../utils/utilityFunctions";
import { FormValues, EconomyCompareResult } from "../types";

interface SimulationDataSummaryProps {
  values: FormValues;
  simulationResult: EconomyCompareResult | null;
  simulacaoSelected: string;
  viewSimulacaoData: boolean;
  onToggleView: () => void;
  onEdit: () => void;
}

export const SimulationDataSummary = ({
  values,
  simulationResult,
  simulacaoSelected,
  viewSimulacaoData,
  onToggleView,
  onEdit,
}: SimulationDataSummaryProps) => (
  <Accordion>
    <div style={{ width: "100%" }}>
      <Accordion.Toggle
        onClick={() => onToggleView()}
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          height: "100px",
          alignItems: "center",
          border: "0",
          padding: "0 20px",
          backgroundColor: "#F5F5F5",
        }}
        eventKey="0"
      >
        <div className="simulacao-dados-left">
          <div
            className="simulacao-editar-button"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onEdit();
            }}
          >
            <img src={arrowleft} alt="voltar icon" />
            <h1>EDITAR</h1>
          </div>
          <span>
            {simulacaoSelected === "ML"
              ? "Simulando mercado livre"
              : simulacaoSelected === "APE"
              ? "Simulando autoprodutor de energia"
              : simulacaoSelected === "MLXAPE"
              ? "Simulando comparação mercado livre x autoprodutor"
              : simulacaoSelected === "GDXAPE"
              ? "Simulando comparação geração distribuída x autoprodutor"
              : simulacaoSelected === "MLBESS"
              ? "Simulando mercado livre com e sem bateria"
              : simulacaoSelected === "APEBESS"
              ? "Simulando autoprodutor com e sem bateria"
              : ""}
          </span>
        </div>
        <div className="simulacao-voltar">
          {viewSimulacaoData ? (
            <>
              <span className="simulacao-dados-button">ESCONDER DADOS</span>
              <img src={arrowup} alt="voltar icon" />
            </>
          ) : (
            <>
              <span className="simulacao-dados-button">VER DADOS</span>
              <img src={arrowdown} alt="voltar icon" />
            </>
          )}
        </div>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey="0">
        <div className="simulacao-accordion-container">
          <div>
            <span className="simulacao-form-header">Dados do cliente</span>
            <hr />
          </div>

          <div className="formLine-data">
            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">CNPJ da Empresa</h1>
              <h2 className="simulacao-form-description">{values.cnpj}</h2>
            </div>
            {values.nomeCliente !== "" ? (
              <div className="simulacao-data-flex">
                <h1 className="simulacao-form-title">Nome do cliente</h1>
                <h2 className="simulacao-form-description">
                  {values.nomeCliente}
                </h2>
              </div>
            ) : (
              <div className="simulacao-data-flex">
                <h1 className="simulacao-form-title">Nome do cliente</h1>
                <h2 className="simulacao-form-description">-</h2>
              </div>
            )}
            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">Custo Operacional e CCEE</h1>
              <h2 className="simulacao-form-description">
                {simulationResult?.custoGestao?.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </h2>
            </div>
          </div>

          <div className="formLine-data">
            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">Distribuidora</h1>
              <h2 className="simulacao-form-description">
                {values.distribuidora}
              </h2>
            </div>
            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">THS</h1>
              <h2 className="simulacao-form-description">{values.ths}</h2>
            </div>
            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">Grupo Tarifário</h1>
              <h2 className="simulacao-form-description">
                {values.grupoTarifario}
              </h2>
            </div>
          </div>

          <div>
            <span className="simulacao-form-header">Dados da fatura</span>
            <hr />
          </div>

          <div className="formLine-data">
            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">
                Demanda contratada P (kW)
              </h1>
              <h2 className="simulacao-form-description">
                {values.demandaPonta} kW
              </h2>
            </div>
            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">
                Demanda Ultrapassagem P (kW)
              </h1>
              <h2 className="simulacao-form-description">
                {+values.demandaPontaUltrapassagem.replace(",", ".") > 0
                  ? values.demandaPontaUltrapassagem
                  : 0}{" "}
                kW
              </h2>
            </div>

            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">Consumo P (kWh)</h1>
              <h2 className="simulacao-form-description">
                {values.consumoPonta} kWh
              </h2>
            </div>
          </div>

          <div className="formLine-data">
            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">
                Demanda contratada FP (kW)
              </h1>
              <h2 className="simulacao-form-description">
                {values.demandaForaPonta} kW
              </h2>
            </div>
            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">
                Demanda Ultrapassagem FP (kW)
              </h1>
              <h2 className="simulacao-form-description">
                {+values.demandaForaPontaUltrapassagem.replace(",", ".") > 0
                  ? values.demandaForaPontaUltrapassagem
                  : 0}{" "}
                kW
              </h2>
            </div>
            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">Consumo FP (kWh)</h1>
              <h2 className="simulacao-form-description">
                {values.consumoForaPonta} kWh
              </h2>
            </div>
          </div>

          {values.isBateria && (
            <>
              <div>
                <span className="simulacao-form-header">Dados de bateria</span>
                <hr />
              </div>

              <div className="formLine-data">
                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">
                    Potência bateria (kW)
                  </h1>
                  <h2 className="simulacao-form-description">
                    {values.potenciaBateria
                      ? `${values.potenciaBateria} kW`
                      : ""}
                  </h2>
                </div>

                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">
                    Energia máxima armazenável (kWh)
                  </h1>
                  <h2 className="simulacao-form-description">
                    {values.energiaMaximaArmazenada
                      ? `${+values.energiaMaximaArmazenada.replace(
                          ",",
                          "."
                        )} kWh`
                      : ""}
                  </h2>
                </div>

                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">RTE (%)</h1>
                  <h2 className="simulacao-form-description">
                    {values.rteBateria}%
                  </h2>
                </div>

                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">Investimento bateria</h1>
                  <h2 className="simulacao-form-description">
                    {formatBrazilianCurrency(
                      parseBrazilianNumber(values.investimentoBateria)
                    )}
                  </h2>
                </div>
              </div>

              {values.medicaoCsvFileName !== "" && (
                <div className="formLine-data">
                  <div className="simulacao-data-flex">
                    <h1 className="simulacao-form-title">
                      Medição horária CCEE
                    </h1>
                    <h2 className="simulacao-form-description">
                      {values.medicaoCsvFileName}
                    </h2>
                  </div>

                  {values.pontoMedicaoBess !== "" && (
                    <div className="simulacao-data-flex">
                      <h1 className="simulacao-form-title">
                        Ponto de medição da bateria
                      </h1>
                      <h2 className="simulacao-form-description">
                        {values.pontoMedicaoBess}
                      </h2>
                    </div>
                  )}

                  <div className="simulacao-data-flex">
                    <h1 className="simulacao-form-title">Submercado</h1>
                    <h2 className="simulacao-form-description">
                      {values.submercado || "-"}
                    </h2>
                  </div>

                  <div className="simulacao-data-flex">
                    <h1 className="simulacao-form-title">
                      DoD — profundidade de descarga
                    </h1>
                    <h2 className="simulacao-form-description">
                      {values.dod}%
                    </h2>
                  </div>
                </div>
              )}
            </>
          )}

          {values.isGerador && (
            <>
              <div>
                <span className="simulacao-form-header">Dados de gerador</span>
                <hr />
              </div>

              <div className="formLine-data">
                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">
                    Consumo gerador (kWh)
                  </h1>
                  <h2 className="simulacao-form-description">
                    {values.consumoGerador
                      ? `${values.consumoGerador} kWh`
                      : ""}
                  </h2>
                </div>

                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">
                    Custo diesel (R$/kWh)
                  </h1>
                  <h2 className="simulacao-form-description">
                    {values.custoDiesel
                      ? formatBrazilianCurrency(
                          parseBrazilianNumber(values.custoDiesel)
                        )
                      : ""}
                  </h2>
                </div>

                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">Custo gerador</h1>
                  <h2 className="simulacao-form-description">
                    {values.custoGerador
                      ? formatBrazilianCurrency(
                          parseBrazilianNumber(values.custoGerador)
                        )
                      : ""}
                  </h2>
                </div>
              </div>
            </>
          )}

          <div>
            <span className="simulacao-form-header">Dados de impostos</span>
            <hr />
          </div>

          <div className="formLine-data">
            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">ICMS</h1>
              <h2 className="simulacao-form-description">{values.icms}%</h2>
            </div>
            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">PIS</h1>
              <h2 className="simulacao-form-description">{values.pis}%</h2>
            </div>
            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">COFINS</h1>
              <h2 className="simulacao-form-description">{values.cofins}%</h2>
            </div>
          </div>

          <div>
            <span className="simulacao-form-header">
              Dados do mercado livre
            </span>
            <hr />
          </div>

          <div className="formLine-data">
            <div className="simulacao-data-flex">
              <h1 className="simulacao-form-title">Desconto</h1>
              <h2 className="simulacao-form-description">
                {values.desconto * 100}%
              </h2>
            </div>
            {values.precoEnergia.map((item, index: number) => (
              <div className="simulacao-data-flex">
                <h1 className="simulacao-form-title">
                  Preço energia {Number(values.initialYear) + index}
                </h1>
                <h2 className="simulacao-form-description">
                  {formatBrazilianCurrency(parseBrazilianNumber(item))}
                </h2>
              </div>
            ))}
          </div>

          {(simulacaoSelected === "APE" ||
            simulacaoSelected === "MLXAPE" ||
            simulacaoSelected === "APEBESS") && (
            <>
              <div>
                <span className="simulacao-form-header">
                  Dados de autoprodutor de energia
                </span>
                <hr />
              </div>

              <div className="formLine-data">
                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">Local da instalação</h1>
                  <h2 className="simulacao-form-description">
                    {values.local ? "Usina local" : "Não é usina local"}
                  </h2>
                </div>
                {values.local && (
                  <div className="simulacao-data-flex">
                    <h1 className="simulacao-form-title">
                      Fator de simultaneidade
                    </h1>
                    <h2 className="simulacao-form-description">
                      {values.simultaneidade}%
                    </h2>
                  </div>
                )}
                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">Geração (kWh)</h1>
                  <h2 className="simulacao-form-description">
                    {values.geracao} kWh
                  </h2>
                </div>
              </div>
              <div className="formLine-data">
                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">
                    Demanda da usina (kW)
                  </h1>
                  <h2 className="simulacao-form-description">
                    {values.demandaUsina} kW
                  </h2>
                </div>
                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">
                    Potência da usina (kWp)
                  </h1>
                  <h2 className="simulacao-form-description">
                    {values.potenciaUsina} kWp
                  </h2>
                </div>
                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">Investimento</h1>
                  <h2 className="simulacao-form-description">
                    {formatBrazilianCurrency(
                      parseBrazilianNumber(values.custoProjeto)
                    )}
                  </h2>
                </div>
              </div>
            </>
          )}

          {simulacaoSelected === "GDXAPE" && (
            <>
              <div>
                <span className="simulacao-form-header">
                  Dados da usina de geração distribuída
                </span>
                <hr />
              </div>

              <div className="formLine-data">
                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">Local da instalação</h1>
                  <h2 className="simulacao-form-description">
                    {values.local ? "Usina local" : "Não é usina local"}
                  </h2>
                </div>

                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">
                    Energia Injetada (kWh)
                  </h1>
                  <h2 className="simulacao-form-description">
                    {values.geracao} kWh
                  </h2>
                </div>

                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">
                    Demanda da usina (kW)
                  </h1>
                  <h2 className="simulacao-form-description">
                    {values.demandaUsina} kW
                  </h2>
                </div>

                <div className="simulacao-data-flex">
                  <h1 className="simulacao-form-title">
                    Potência da usina (kWp)
                  </h1>
                  <h2 className="simulacao-form-description">
                    {values.potenciaUsina} kWp
                  </h2>
                </div>
              </div>
            </>
          )}
        </div>
      </Accordion.Collapse>
    </div>
  </Accordion>
);
